import React from 'react';

export function useMediaQuery(query: string): boolean {
  const [ matches, setMatches ] = React.useState(false);

  React.useEffect(() => {
    setMatches(window.matchMedia(query).matches);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    'addEventListener' in mediaQuery
      ? mediaQuery.addEventListener('change', handler)
      : (mediaQuery as any).addListener(handler);

    return () => {
      'addEventListener' in mediaQuery
        ? mediaQuery.removeEventListener('change', handler)
        : (mediaQuery as any).removeListener(handler);
    };
  }, [ query ]);

  return matches;
}